import { Text } from "@acko-tech/building-blocks.ui.typography";
import styled from "styled-components";

export const ErrorMessage = styled(Text)`
  color: #d83d37;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  margin-top: 8px;
`;

export const Wrapper = styled.div`
  width: 100%;
  ${(props: { wrapperStyles: any }) =>
    props.wrapperStyles}// @media (max-width: 768px) {
  //   width: 100%;
  // }
`;
